"use client";

import React from "react";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocaleRouter } from "@/hooks/useLocaleRouter";
import { Title, Text } from "@/components/ui/Headings";

const FinalCtaBanner: React.FC = () => {
  const { t } = useTranslation();
  const { createLocalizedPath } = useLocaleRouter();
  return (
    <section className="relative py-6 sm:py-6 lg:py-10 bg-primary-900 hidden md:block">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/2506923/pexels-photo-2506923.jpeg?auto=compress&cs=tinysrgb&w=1920&h=800&fit=crop)",
        }}
      >
        <div className="absolute inset-0 bg-primary-900/80"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
        <Title
          size="lg"
          className="text-white mb-5 sm:mb-6 lg:mb-8 leading-tight"
        >
          {t("home.finalCta.heading")}
        </Title>
        <Text
          variant="subtitle"
          className="text-white mb-8 sm:mb-10 lg:mb-10 max-w-2xl mx-auto leading-relaxed text-lg sm:text-xl lg:text-xl"
        >
          {t("home.finalCta.body")}
        </Text>
        <Link
          href={createLocalizedPath("/contact")}
          className="inline-flex items-center bg-white text-primary-900 px-8 py-4 sm:px-10 sm:py-5 rounded-full text-base sm:text-lg lg:text-xl font-semibold hover:bg-neutral-cream transition-all duration-300 transform hover:scale-105 touch-target shadow-xl"
        >
          {t("home.finalCta.cta")}
          <ChevronRight className="ml-2 h-5 w-5 sm:h-6 sm:w-6" />
        </Link>
      </div>
    </section>
  );
};

export default FinalCtaBanner;
